import get from 'lodash/get';

export const filters = state => get(state, 'form.automatonsFilters.values');
export const filterOffline = state => get(state, 'automatons.filterOffline');
